/* eslint-disable no-shadow */
import common from "../helpers/common";
import authService from "../service/auth.service";

const state = {
  isLoading: false,
  data: {
    token: null,
    expires_at: null,
    expires_in: null,
    refresh_token: null,
    utc_now: null,
  },
};

const actions = {
  async setToken({ commit }) {
    const result = await authService.getToken({});
    commit("SET_TOKEN", result);
    return result;
  },
};

const mutations = {
  SET_TOKEN(state, data) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("access_token_expired_at");

    // const EXPIRES_IN = 30; //data.expires_in;
    const EXPIRES_IN = data.expires_in;
    state.data.token = data.access_token;
    state.data.expires_in = EXPIRES_IN;
    state.data.expires_at = common.getNowUTC().add(EXPIRES_IN, "second");
    state.data.utc_now = common.getNowUTC();
    state.data.refresh_token = data.refresh_token;

    localStorage.setItem("access_token", state.data.token);
    localStorage.setItem("access_token_expired_at", state.data.expires_at);
  },
};

const getters = {};

const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default auth;
